// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "f2bf437b19efae26" + ".js";
};